import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { DatePicker } from '../../DatePicker/DatePicker.es.js';
import { FilterGroupContent } from '../FilterGroup.Content/FilterGroup.Content.es.js';
import { useFilterGroup } from '../FilterGroup.Context/index.es.js';

const FilterDateRange = ({ name, onChange, self, ...props })=>{
    const { filters, setFilter } = useFilterGroup();
    const filter = filters?.[name] ?? {};
    // Format date value
    const getDateValue = useCallback((date)=>{
        if (Array.isArray(date)) {
            const [from, to] = date;
            return {
                from,
                to
            };
        }
    }, []);
    const handleChange = useCallback((dates)=>{
        const value = getDateValue(dates);
        setFilter(name, value, self);
        onChange?.(value);
    }, [
        name,
        onChange,
        self,
        setFilter,
        getDateValue
    ]);
    return jsx(FilterGroupContent, {
        "data-testid": "filter-group-date-range",
        id: name,
        children: jsx(DatePicker.Range, {
            ...props,
            endDate: filter?.to,
            intent: "filter",
            onChange: handleChange,
            startDate: filter?.from
        })
    });
};
FilterDateRange.displayName = 'FilterGroup.Filters.DatePicker';

export { FilterDateRange };
//# sourceMappingURL=FilterGroup.DateRange.es.js.map
